import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum – creategy" },
      { name: "description", content: "Impressum und Anbieterkennzeichnung der creategy GmbH." },
      { property: "og:title", content: "Impressum – creategy" },
      { property: "og:description", content: "Impressum der creategy GmbH." },
      { property: "og:url", content: "https://creategy.de/impressum" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://creategy.de/impressum" }],
  }),
  component: ImpressumPage,
});

const OFFICES = [
  {
    label: "Headquarter Berlin",
    street: "Danziger Straße 6",
    zip: "10435 Berlin",
  },
  {
    label: "Regionalbüro Rhein-Main",
    street: "Hainstädter Straße 29",
    zip: "63512 Hainburg",
  },
  {
    label: "Regionalbüro Baden-Württemberg",
    street: "Heinrich-Bettinger Str. 14",
    zip: "78333 Stockach",
  },
];

function Section({
  title,
  children,
  first = false,
}: {
  title: string;
  children: React.ReactNode;
  first?: boolean;
}) {
  return (
    <div className={first ? "" : "border-t border-border pt-8"}>
      <h2 className="heading-h3 text-primary">{title}</h2>
      <div className="mt-4 font-body text-base leading-relaxed text-foreground">
        {children}
      </div>
    </div>
  );
}

const linkClass =
  "inline-flex items-center border-b border-primary pb-0.5 text-primary transition-opacity hover:opacity-80";

function ImpressumPage() {
  return (
    <Layout>
      <section>
        <div className="mx-auto max-w-3xl px-6 md:px-12 section-y-hero">
          <h1 className="heading-h1 text-primary">Impressum</h1>

          <div className="mt-12 space-y-10">
            <Section title="Angaben gemäß § 5 TMG" first>
              <p>
                creategy GmbH
                <br />
                Danziger Straße 6
                <br />
                10435 Berlin
              </p>
              <p className="mt-4">
                Handelsregister: HRB 727659
                <br />
                Registergericht: Amtsgericht Freiburg
              </p>
            </Section>

            <Section title="Standorte">
              <div className="grid gap-8 md:grid-cols-3">
                {OFFICES.map((office) => (
                  <div key={office.label}>
                    <h3 className="heading-h3 text-primary">{office.label}</h3>
                    <address className="mt-3 not-italic">
                      {office.street}
                      <br />
                      {office.zip}
                    </address>
                  </div>
                ))}
              </div>
            </Section>

            <Section title="Vertreten durch">
              <p>Simon Mai &amp; Chwalibog Paschalis Bouman</p>
            </Section>

            <Section title="Kontakt">
              <p>
                Telefon:{" "}
                <a href="tel:+493027693422" className={linkClass}>
                  030 27693422
                </a>
                <br />
                E-Mail:{" "}
                <a href="mailto:hello@creategy.de" className={linkClass}>
                  hello@creategy.de
                </a>
              </p>
            </Section>

            <Section title="Steuerliche Angaben">
              <p>
                Steuernummer: 37/254/53871
                <br />
                USt-ID: DE356700125
              </p>
            </Section>

            <Section title="Redaktionell verantwortlich">
              <p>
                creategy GmbH | Danziger Straße 6 | 10435 Berlin
                <br />
                Geschäftsführer: Simon Mai, Chwalibóg Paschalis Bouman
              </p>
            </Section>

            <Section title="EU-Streitschlichtung">
              <p>
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                .
                <br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </Section>

            <Section title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
              <p>
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
                teilzunehmen.
              </p>
            </Section>
          </div>
        </div>
      </section>
    </Layout>
  );
}
